import React, { useState, useEffect } from 'react';
import PageHero from './PageHero';
import './Contact.css';

const Contact = ({ onFormSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    service: '',
    requestDemo: false,
    message: ''
  });
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission disabled - users should contact via email directly
    window.location.href = 'mailto:connect@rivontrix.com?subject=Contact Form Inquiry&body=' + 
      encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\nCompany: ${formData.company}\nService: ${formData.service}\nMessage: ${formData.message}`);
  };

  useEffect(() => {
    try {
      const url = new URL(window.location.href);
      const demo = url.searchParams.get('demo');
      if (demo === 'shieldex') {
        setFormData((prev) => ({
          ...prev,
          service: 'shieldex',
          requestDemo: true
        }));
      }
    } catch (e) {
      // no-op for environments without window
    }
  }, []);

  return (
    <>
      <PageHero
        sectionId="contact"
        title="Get In Touch"
        subtitle="Contact Us"
        description="Ready to transform your enterprise? Let's discuss how Rivontrix can help you with AI-driven cybersecurity, digital transformation, and expert talent solutions."
        image="https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=1600&q=80"
        gradient="linear-gradient(135deg, rgba(102, 126, 234, 0.9), rgba(118, 75, 162, 0.9))"
      />
      <section id="contact" className="contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-item">
              <div className="info-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div className="info-content">
                <h4>Email</h4>
                <p>connect@rivontrix.com</p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div className="info-content">
                <h4>Office</h4>
                <p>Global Headquarters - Singapore</p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon">
                <i className="fas fa-clock"></i>
              </div>
              <div className="info-content">
                <h4>Business Hours</h4>
                <p>Monday - Friday: 9am - 6pm</p>
              </div>
            </div>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your.email@example.com"
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="company">Company</label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder="Your Company"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="service">Service Interest</label>
              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
              >
                <option value="">Select a service</option>
                <option value="consulting">Rivontrix Consulting</option>
                <option value="shieldex">ShieldEx Cybersecurity</option>
                <option value="genai">Generative AI (GenAI)</option>
                <option value="techtalent">TechTalentPro</option>
                <option value="general">General Inquiry</option>
              </select>
            </div>
            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="requestDemo"
                  checked={formData.requestDemo}
                  onChange={(e) => setFormData({ ...formData, requestDemo: e.target.checked })}
                />
                <span>Request Cybersecurity Product Demo (ShieldEx)</span>
              </label>
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell us about your project or requirements..."
                rows="5"
                required
              ></textarea>
            </div>
            <button type="submit" className="submit-btn">
              Open Email Client
              <i className="fas fa-envelope"></i>
            </button>
          </form>
        </div>
      </div>
    </section>
    </>
  );
};

export default Contact;

